import React, { useEffect, useMemo, useState } from 'react';
import { AutocompleteComponent } from '../../../../../../../../Components';
import { GetAllVendorServices } from '../../../../../../../../Services';
import { useTranslation } from 'react-i18next';
import { showError } from '../../../../../../../../Helper';

const ServicesAutocomplete = ({
  parentTranslationPath,
  onChange,
  selectedCategory,
  selectedService,
  vendorId,
  ...props
}) => {
  const { t } = useTranslation(parentTranslationPath);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const getVendorServices = async () => {
    try {
      const { result } = await GetAllVendorServices(vendorId, {
        pageSize: 100,
        pageIndex: 1,
      });
      setData(result);
    } catch (error) {
      showError(t('something_went_wrong'));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!!vendorId) {
      getVendorServices();
    }
  }, [vendorId]);

  const filteredData = useMemo(
    () =>
      data.filter((item) => item.vendorServiceCategoryId === selectedCategory),
    [data, selectedCategory]
  );
  return (
    <AutocompleteComponent
      data={filteredData}
      displayLabel={(option) => option.serviceType}
      getOptionSelected={(option, value) =>
        option.vendorServiceId === value.vendorServiceId
      }
      selectedValues={selectedService}
      labelValue={'service_name'}
      multiple={false}
      isLoading={isLoading}
      parentTranslationPath={parentTranslationPath}
      onChange={onChange}
      withoutSearchButton
      isDisabled={!selectedCategory}
      {...props}
    />
  );
};
export default ServicesAutocomplete;
